// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Components
import Link from 'ui/components/Link'

// Shared
import { Routing as RoutingUtils } from 'back_office/v2/utils/utils'

// Help Center URLs mapping
export const HELP_CENTER_URLS = {
  '2fa_enforcing': 'https://help.booqable.com/en/articles/5939071',
  'advanced_pricing': 'https://help.booqable.com/en/articles/3701999',
  'away_mode': 'https://help.booqable.com/en/articles/2003151',
  'barcodes': 'https://help.booqable.com/en/collections/3501951',
  'buffer_times': 'https://help.booqable.com/en/articles/90053',
  'bundles': 'https://help.booqable.com/en/articles/3797998',
  'coupons': 'https://help.booqable.com/en/articles/2549062',
  'downtimes': 'https://help.booqable.com/en/articles/12505664',
  'exports': 'https://help.booqable.com/en/articles/5603655',
  'iprestrictions': 'https://help.booqable.com/en/articles/3973615',
  'manual_email_templates': 'https://help.booqable.com/en/articles/974152',
  'packing_slips': 'https://help.booqable.com/en/articles/8100428',
  'permissions': 'https://help.booqable.com/en/articles/607225',
  'prevent_last_minute_reservations': 'https://help.booqable.com/en/articles/800357',
  'product_security_deposit': 'https://help.booqable.com/en/articles/101604',
  'product_shortage_limits': 'https://help.booqable.com/en/articles/3684264',
  'reports': 'https://help.booqable.com/en/articles/8140879',
  'sales_items': 'https://help.booqable.com/en/articles/5210103',
  'sso': 'https://help.booqable.com/en/articles/3543536',
  'custom_fields': 'https://help.booqable.com/en/articles/2170699',
  'tags': 'https://help.booqable.com/en/articles/2990771',
  'custom_domains': 'https://help.booqable.com/en/collections/9551013',
  'booking_page': 'https://help.booqable.com/en/articles/798239',
  'menu': 'https://help.booqable.com/en/articles/6633179',
  'image-recommendations': 'https://help.booqable.com/en/articles/10214297-image-recommendations-for-your-store'
}

/**
 * HelpCenterLink component
 *
 * @example
 *   // Using URL identifier (preferred)
 *   <HelpCenterLink id="advanced_pricing">Learn about pricing</HelpCenterLink>
 *
 *   // Using direct href (legacy)
 *   <HelpCenterLink href="https://help.booqable.com/en/articles/3701999">Learn about pricing</HelpCenterLink>
 */
// eslint-disable-next-line no-restricted-exports
export default class HelpCenterLink extends Component {
  static displayName = 'HelpCenterLink'

  static propTypes = {
    id: PropTypes.string,
    href: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
      PropTypes.array
    ])
  }

  render () {
    const { children, id, href, ...otherProps } = this.props

    // Determine the URL to use - prefer id lookup over direct href
    const resolvedHref = id ? HELP_CENTER_URLS[id] : href

    // Don't render if no valid URL is found
    if (!resolvedHref) return null

    return (
      <Link
        href={resolvedHref}
        target="_blank"
        rel="noopener noreferrer"
        data-track-event="Help center link clicked"
        onClick={RoutingUtils.navigateLink}
        {...otherProps}
      >
        {children.length !== 0 && <span>{children}</span>}
      </Link>
    )
  }
}
